import React, { useState } from 'react';
import { Tooltip, Row, Col } from 'antd';

import {
  TableColumnTitle,
  PrimaryTableRowText,
  TooltipText,
} from '../../../../../../shared/globalStyling/styledText';
import { formatWholeNumber, formatCurrency2SigFig } from '../../../../../../../core/utils/campaigns';
import uuid from 'uuid';
import SimpleTable from '../../../../../../shared/SimpleTable';

const BasketItemTable = ({ basketItemData }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const columns = [
    {
      title: '',
      dataIndex: 'color',
      key: 'color',
      width: '40px',
      render: (text) => {
        return (
          <Row
            type="flex"
            justify="center"
            align="middle"
            style={{
              width: '100%',
            }}
          >
            <div
              style={{
                backgroundColor: text,
                height: '15px',
                width: '15px',
                minWidth: '15px',
                borderRadius: '50px',
              }}
            />
          </Row>
        );
      },
    },
    {
      title: <TableColumnTitle text={'Name'} />,
      dataIndex: 'name',
      key: 'name',
      width: '250px',
      align: 'left',
      footerContent: 'Totals + Averages',
      sorter: (a, b) => (a.name || '').localeCompare(b.name || ''),
      render: (text, record) => {
        if (text) {
          return (
            <Row
              type="flex"
              justify="start"
              align="middle"
              style={{
                width: '100%',
              }}
            >
              <Col span={24}>
                {text.length > 45 ? (
                  <Tooltip title={<TooltipText text={text} />}>
                    <span>
                      <PrimaryTableRowText text={text.slice(0, 46).concat('...')} />
                    </span>
                  </Tooltip>
                ) : (
                  <PrimaryTableRowText text={text} />
                )}
              </Col>
            </Row>
          );
        } else {
          return <div />;
        }
      },
    },
    {
      title: <TableColumnTitle text={'Quantity'} />,
      dataIndex: 'quantity',
      footerSum: true,
      key: 'quantity',
      width: '130px',
      align: 'left',
      sorter: (a, b) => a.quantity - b.quantity,
      render: (quantity) => (
        <PrimaryTableRowText text={quantity && formatWholeNumber(quantity)} />
      ),
    },
    {
      title: <TableColumnTitle text={'Total'} />,
      dataIndex: 'total',
      footerSum: true,
      key: 'total',
      width: '130px',
      align: 'left',
      sorter: (a, b) => a.total - b.total,
      render: (total) => (
        <PrimaryTableRowText text={total && formatCurrency2SigFig(total)} />
      ),
    },
  ];

  return (
    <SimpleTable
      footer={basketItemData.slice(currentPage * 10 - 10, currentPage * 10)}
      bordered={false}
      columns={columns}
      data={basketItemData.map((item) => {
        return {
          ...item,
          key: `${item.id}${uuid.v4()}`,
        };
      })}
      scroll={{ x: 200, y: 400 }}
      onChange={(paginationObject, filtersObject, sorterObject) => {
        setCurrentPage(paginationObject.current);
      }}
      pagination={{
        pageSize: 10,
        total: basketItemData.length,
        current: currentPage,
      }}
    />
  );
};

export default BasketItemTable;
